import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { Helmet, HelmetProvider } from "react-helmet-async";
import ScrollSpy from "react-ui-scrollspy";
import GotoTop from "../common/GotoTop";
import ContactCTA from "../contact/contactCTA";
import Analytics_Banner from "./Analytics_Banner";
import Analytics_faq from "./Analytics_faq";
import Analytics_Info from "./Analytics_Info";
import Analytics_services from "./Analytics_services";
import { motion } from "framer-motion";


const Analytics_Home = () => {
  return (
    <div>
      <HelmetProvider>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Flint Infotech - IT Services, Consulting & AI Solutions</title>
          <meta
            name="description"
            content="Unlock strategic growth with Flint Infotech's IT services, consulting, and AI Solutions solutions. Transform your data into actionable insights for improved decision-making and business success."
          />
          <link rel="canonical" href="https://flintinfotech.com/" />

          <meta
            property="og:title"
            content="Flint Infotech - IT Services, Consulting & AI Solutions"
          />
          <meta
            property="og:description"
            content="Unlock strategic growth with Flint Infotech's IT services, consulting, and AI Solutions solutions. Transform your data into actionable insights for improved decision-making and business success."
          />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://flintinfotech.com/" />

          <meta name="twitter:card" content="summary_large_image" />
          <meta
            name="twitter:title"
            content="Flint Infotech - IT Services, Consulting & AI Solutions"
          />
          <meta
            name="twitter:description"
            content="Unlock strategic growth with Flint Infotech's IT services, consulting, and AI Solutions solutions. Transform your data into actionable insights for improved decision-making and business success."
          />

          <meta name="robots" content="index, follow" />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0"
          />
        </Helmet>
      </HelmetProvider>

      <ScrollSpy>
        {/* <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp"> */}
        <Analytics_Banner />
        {/* </AnimationOnScroll> */}
      <motion.div
  initial={{ opacity: 0, y: 40 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true, amount: 0.2 }}
  transition={{ duration: 0.6 }}
>
  <Analytics_Info />
</motion.div>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Analytics_services />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <Analytics_faq />
        </AnimationOnScroll>
        <AnimationOnScroll animateOnce="true" animateIn="animate__fadeInUp">
          <ContactCTA />
        </AnimationOnScroll>
      </ScrollSpy>
      <GotoTop />
    </div>
  );
};

export default Analytics_Home;
